
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DescriptionSummary extends Vue {
  @Prop(String) readonly title!: string;
}
